<template>
  <div class="cookieBanner">
    <p>
      {{ $t("generic.rgpd.banner.message") }}
      <!--
      <router-link
        class="--no-style"
        to="/"
      >
        {{
          $t("general.more")
        }}
      </router-link>
      -->
    </p>
    <div class="flex mt-2">
      <button
        class="btn btn btn--squared btn__secondary mr-5"
        @click="rejectCookiesPolicy"
      >
        {{ $t('generic.rgpd.banner.no') }}
      </button>
      <button
        class="btn btn--squared btn__fitMode"
        @click="acceptCookiesPolicy"
      >
        {{ $t("generic.rgpd.banner.yes") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'CookieBanner',

  methods: {
    acceptCookiesPolicy() {
      this.updateCookiesPolicyStatus('accept');
    },

    rejectCookiesPolicy() {
      this.updateCookiesPolicyStatus('reject');
    },

    ...mapActions('user', ['updateCookiesPolicyStatus'])
  }
};
</script>

<style lang="postcss">
.cookieBanner{
  @apply z-50 bg-gray-20 fixed flex flex-col justify-between max-w-md p-5 rounded-lg shadow;
  bottom: 1rem;
  right: 1rem;
}
@media only screen and (max-width: 500px) {
  .cookieBanner{
    @apply w-full bottom-0 right-0 left-0 text-xs;
  }
}
</style>
